// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-row-operations a[data-v-0ba65632]{margin-right:8px}.editable-add-btn[data-v-0ba65632]{margin-top:8px}#salesform .ant-form-item[data-v-0ba65632]{margin-bottom:0!important}#salesform .ant-form-item-control[data-v-0ba65632],#salesform .ant-form-item-control-wrapper[data-v-0ba65632],#salesform .ant-form-item-label[data-v-0ba65632]{padding:0}", ""]);
// Exports
module.exports = exports;
